import { render } from "./WhatsAppIcon.vue?vue&type=template&id=32d8d5b0&scoped=true"
import script from "./WhatsAppIcon.vue?vue&type=script&lang=js"
export * from "./WhatsAppIcon.vue?vue&type=script&lang=js"

import "./WhatsAppIcon.vue?vue&type=style&index=0&id=32d8d5b0&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3011205126/src/emulator.totogidemos.com/frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32d8d5b0"]])

export default __exports__